export const getGenerationTemplateType = (name = '') => String(name)
  .split('?')[0]
  .split('#')[0]
  .split('.')
  .pop()
  .toLowerCase();

export const supportsDocGenReview = (name = '') => getGenerationTemplateType(name) === 'docx';
